import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'member',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: lazy(() => import('@/page/user/MemberListPage')),
      },
    ],
  },
];

export default routes;
